// Demo/mock data used only as an offline fallback when the `excesses` API
// is unreachable (e.g. local dev without the backend endpoint yet).
// Remove this file and the fallback wiring in useExcessList.js / Excess.vue
// once the real backend endpoints are live.

const WAREHOUSES = [
  'Shinyanga Central WH', 'Mwanza Lake WH', 'Kahama Buying Post',
  'Geita Regional WH', 'Singida Hub WH', 'Tabora Main WH',
]

const PEOPLE = [
  { firstName: 'Juma', middleName: null, lastName: 'Mwakimbe' },
  { firstName: 'Asha', middleName: 'N.', lastName: 'Kessy' },
  { firstName: 'Elias', middleName: null, lastName: 'Mrema' },
  { firstName: 'Fatuma', middleName: null, lastName: 'Said' },
  { firstName: 'Daniel', middleName: 'K.', lastName: 'Mushi' },
  { firstName: 'Grace', middleName: null, lastName: 'Lyimo' },
]

function buildBale(i) {
  const purchased = 16 + ((i * 13) % 40) - 5
  const cromisRecent = purchased - (i % 4)
  const driftKg = [0, 0.5, -0.8, 3.4, -4.1, 1.2, 6.8, -7.5, 0.2, 2.9][i % 10]
  const received = +(cromisRecent + driftKg).toFixed(2)
  const hasTf = i % 5 !== 0
  const statusCycle = i % 5
  const approved = statusCycle === 0 ? 1 : statusCycle === 1 ? -1 : 0
  const daysAgo = (i * 7) % 21
  const date = new Date()
  date.setDate(date.getDate() - daysAgo)

  const src = WAREHOUSES[i % WAREHOUSES.length]
  let dst = WAREHOUSES[(i + 2) % WAREHOUSES.length]
  if (dst === src) dst = WAREHOUSES[(i + 3) % WAREHOUSES.length]

  const person = PEOPLE[i % PEOPLE.length]

  return {
    id: 9000 + i,
    received_at: date.toISOString(),
    ticket: {
      barcode: `26${(81000 + i * 37).toString().padStart(9, '0')}`,
      mass: purchased,
    },
    transport: hasTf ? { number: `${(152605148 + i * 53).toString()}` } : null,
    source: { name: src },
    destination: { name: dst },
    previous: cromisRecent,
    current: received,
    scanner: { person },
    approved,
    authLog: approved !== 0 ? [
      {
        user: 'Hassan Mbwana',
        role: 'Warehouse Supervisor',
        timestamp: new Date(date.getTime() + 3600 * 1000 * 5).toLocaleString(),
        note: approved === 1
          ? 'Confirmed physically present at destination, weight within tolerance. Accepted into stock.'
          : 'Could not verify against any TF or MTS record — flagged as unexplained excess and rejected.',
        action: approved === 1 ? 'approved' : 'rejected',
      },
    ] : [],
  }
}

export const MOCK_EXCESS_BALES = Array.from({ length: 27 }, (_, i) => buildBale(i + 1))

export const MOCK_EXCESS_METRICS = {
  registered: MOCK_EXCESS_BALES.length,
  pending: MOCK_EXCESS_BALES.filter(b => Number(b.approved) === 0).length,
  approved: MOCK_EXCESS_BALES.filter(b => Number(b.approved) === 1).length,
  rejected: MOCK_EXCESS_BALES.filter(b => Number(b.approved) === -1).length,
}

function getField(item, key) {
  if (key === 'received_at') return item.received_at
  if (key === 'barcode') return item.ticket.barcode
  return item[key]
}

export function queryMockExcess({ query, per_page = 10, page = 1, sortBy = 'received_at', sortDesc = true }) {
  let rows = [...MOCK_EXCESS_BALES]

  if (query && query.trim()) {
    const q = query.trim().toLowerCase()
    rows = rows.filter(b =>
      b.ticket.barcode.toLowerCase().includes(q) ||
      (b.transport && b.transport.number.toLowerCase().includes(q)) ||
      b.source.name.toLowerCase().includes(q) ||
      b.destination.name.toLowerCase().includes(q) ||
      (b.scanner && b.scanner.person &&
        `${b.scanner.person.firstName} ${b.scanner.person.lastName}`.toLowerCase().includes(q))
    )
  }

  rows.sort((a, b) => {
    const av = getField(a, sortBy)
    const bv = getField(b, sortBy)
    if (av < bv) return sortDesc ? 1 : -1
    if (av > bv) return sortDesc ? -1 : 1
    return 0
  })

  const total = rows.length
  const start = (page - 1) * per_page
  const pageRows = rows.slice(start, start + per_page)

  return {
    excesses: pageRows,
    meta: {
      from: total === 0 ? 0 : start + 1,
      to: Math.min(start + per_page, total),
      total,
      current_page: page,
      last_page: Math.max(1, Math.ceil(total / per_page)),
      per_page,
    },
  }
}
